export function blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  if ("arrayBuffer" in blob && typeof blob.arrayBuffer === "function") return blob.arrayBuffer();
  return new Promise((resolve, reject) => {
    if (typeof FileReader !== "undefined") {
      try {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as ArrayBuffer);
        reader.onerror = () => reject(reader.error);
        reader.readAsArrayBuffer(blob);
        return;
      } catch {
        // Continue to Response fallback for non-DOM Blob implementations.
      }
    }
    if (typeof Response !== "undefined") {
      new Response(blob).arrayBuffer().then(resolve, reject);
      return;
    }
    reject(new Error("Blobを読み取れませんでした。"));
  });
}
